export function getActiveValues(servObj) {
    return Object.entries(servObj)
        .filter(([key, value]) => key.startsWith("active") && Array.isArray(value) && value.length > 0)
        .flatMap(([key, value]) => value);
}
